export const IconButton: React.FC<any> = ({
  Icon,
  text,
  onClick,
  disabled,
}) => {
  return (
    <div className="text-gray-900 dark:text-gray-100  hover:text-primary-light dark:hover:text-primary-light">
      <button
        onClick={onClick}
        disabled={disabled}
        className="btn btn-primary flex flex-row"
      >
        <Icon className="h-6 w-6" />
        {text}
      </button>
    </div>
  );
};
